import React from "react";
import Select from "react-select";

function SelectRows({ setPageSize, onChange, pageSize, options }) {
  return (
    <Select
      className="w-full"
      value={pageSize}
      onChange={(e) => onChange(e)}
      defaultValue={options[0]}
      options={options}
    />
  );
}

export default SelectRows;
